import React, { useCallback, useContext, useEffect, useState } from "react";
import { Col, Row, Card } from "@themesberg/react-bootstrap";
import { Context } from "../Order";
import { getSummaryClassicCart } from "../../../../controller/api/__classic__/cart";
import { useCookies } from "react-cookie";

const _Summary = () => {
  const { state } = useContext(Context);
  const [cookies] = useCookies(["lottmekong"]);

  const [summary, setSummary] = useState({
    total: 0,
    totalOrders: 0,
    totalValue: 0,
    data: [],
  });

  const getSummaryFunc = useCallback(async () => {
    const query = {
      from: state.filter.from,
      to: state.filter.to,
      phone: state.filter.phone,
    };

    if (state.filter.isDone !== undefined) {
      query.isDone = state.filter.isDone;
    }

    if (state.filter.region !== "") {
      query.region = state.filter.region;
    }

    if (state.filter.dialFrom) {
      query.dialFrom = state.filter.dialFrom;
    }

    if (state.filter.dialTo) {
      query.dialTo = state.filter.dialTo;
    }

    const response = await getSummaryClassicCart(cookies.lottmekong, query);

    if (response) {
      const res = {
        total: response.total,
        totalOrders: response.totalOrders || 0,
        totalValue: response.totalValue || 0,
        data: response.data,
      };
      setSummary(res || {});
    }
  }, [
    cookies.lottmekong,
    state.filter.from,
    state.filter.to,
    state.filter.dialFrom,
    state.filter.dialTo,
    state.filter.phone,
    state.filter.isDone,
    state.filter.region,
  ]);

  useEffect(() => {
    getSummaryFunc();
  }, [getSummaryFunc, state.filterPressCount]);

  const StatCard = ({ title, value, variant = "primary", isCurrency = false }) => (
    <Card
      border="light"
      className={`shadow-sm h-100 border-0 border-start border-4 border-${variant}`}
      style={{ transition: "transform 0.2s" }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.className = e.currentTarget.className.replace(
          "shadow-sm",
          "shadow"
        );
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.className = e.currentTarget.className.replace(
          "shadow",
          "shadow-sm"
        );
      }}
    >
      <Card.Body className="py-3 px-4">
        <div className="text-muted small fw-bold text-uppercase mb-1">
          {title}
        </div>
        <h3 className={`fw-bold text-${variant} mb-0`}>
          {new Intl.NumberFormat("vi-VN").format(value)}{isCurrency ? "đ" : ""}
        </h3>
      </Card.Body>
    </Card>
  );

  const getVariantByIndex = (index) => {
    const variants = ["primary", "success", "info", "warning", "danger"];
    return variants[index % variants.length];
  };

  return (
    <Row className="mb-4 g-3">
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng đơn"
          value={summary.totalOrders}
          variant="primary"
        />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng vé"
          value={summary.total}
          variant="info"
        />
      </Col>
      <Col md={3} sm={6} xs={6}>
        <StatCard
          title="Tổng tiền"
          value={summary.totalValue}
          variant="success"
          isCurrency={true}
        />
      </Col>

      {summary.data.map((item, index) => {
        const userTypeLabel =
          item.userType === 1
            ? "Bán quầy"
            : item.userType === 0
              ? "Bán online"
              : "Trả ế";
        const title = `${item.name} - ${userTypeLabel}`;

        return (
          <Col key={`${item.name}-${item.userType}`} md={3} sm={6} xs={6}>
            <StatCard
              title={title}
              value={item.sum}
              variant={getVariantByIndex(index + 1)}
            />
          </Col>
        );
      })}
    </Row>
  );
};

export default React.memo(_Summary);
